/**
 * This file is auto-generated from MainFooter.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const healedHomepage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed homepage';
        case 'pl':
            return 'Strona główna Healed';
    }
};

export const footerForPatients: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'For Patients';
        case 'pl':
            return 'Dla Pacjentów';
    }
};

export const footerForPhysicians: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'For Physicians';
        case 'pl':
            return 'Dla Lekarzy';
    }
};

export const footerEmergencyNotice: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed is not for emergencies – call 112 in urgent cases.';
        case 'pl':
            return 'Healed nie jest dla nagłych przypadków – w pilnych sprawach zadzwoń pod 112.';
    }
};

export const footerPrivacyPolicy: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Privacy Policy';
        case 'pl':
            return 'Polityka Prywatności';
    }
};

export const footerTermsOfService: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Terms of Service';
        case 'pl':
            return 'Warunki Użytkowania';
    }
};

export const footerAccessibilityStatement: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Accessibility Statement';
        case 'pl':
            return 'Oświadczenie o Dostępności';
    }
};

export const footerLegalNotice: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Legal Notice';
        case 'pl':
            return 'Informacje Prawne';
    }
};
